import { useNavigate } from '@tanstack/react-router';
import type { SavedReportItem } from '../api/types';
import { useDataStructureQuery, useSwitchAccountMutation } from '../api/queries';
import { useAccountStore } from '../lib/account-store';
import {
  buildPendingSavedSearchPayload,
  persistPendingSavedSearchPayload,
} from '../lib/saved-searches';

export const useOpenSavedSearch = () => {
  const navigate = useNavigate();
  const account = useAccountStore(state => state.account);
  const switchAccountMutation = useSwitchAccountMutation();
  const { data: dataStructure } = useDataStructureQuery();

  return async (report: SavedReportItem) => {
    if (!account?._id) {
      throw new Error('No se encontró la cuenta activa para abrir la búsqueda guardada.');
    }

    const tables = dataStructure?.tables ?? [];
    const payload = buildPendingSavedSearchPayload(report, tables);
    if (!payload) {
      throw new Error('La búsqueda guardada no tiene la información necesaria para abrirse.');
    }

    persistPendingSavedSearchPayload(payload);

    if (account.dataset !== payload.datasetId || account.table !== payload.tableId) {
      await switchAccountMutation.mutateAsync({
        account: account._id,
        dataset: payload.datasetId,
        table: payload.tableId,
      });
    }

    await navigate({
      to: '/data/table/$tableId',
      params: { tableId: payload.tableId },
    });
  };
};
